import { Component, Host, h, Element, Prop } from '@stencil/core';
import { Flavor } from './types';

export interface AhaBadge extends HTMLAhaBadgeElement {}

/**
 * A simple component to make a colored badge with some text inside it.
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-badge',
  styleUrl: 'aha-badge.css',
  shadow: true,
})
export class AhaBadge {
  @Element() host!: HTMLAhaBadgeElement;

  // The color of the badge.
  @Prop({ reflect: true }) flavor: Flavor = 'blue';

  // Whether the color will be "normal" (dark text on a light background) or "inverted" (light text on a dark background).
  @Prop({ reflect: true }) invert?: boolean;
  // The size of the badge.
  @Prop({ reflect: true }) size: 'text-based' | 'medium' = 'text-based';

  render() {
    return (
      <Host>
        <div>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
